import React from 'react';
import { isEmptyString } from '../../lib/Utils';

const DollarFormatter = (props) =>{
  let { value, emptyText, color } = props;
  value = parseFloat(value);
  if (isEmptyString(value) || isNaN(value)) {
    return <div><font color="lightGrey">
      {emptyText}
  </font></div>;
  }
  return <div><font color={color}>{'$' + value.toFixed(2)} </font></div>;
};


export class GreyDollarFormatter extends React.Component {
  render() {
    let { value } = this.props;
    return <DollarFormatter color={"grey"} value={value} emptyText="No Data" />;
  }
}

export class GenericDollarFormatter extends React.Component {
  render() {
    let { value } = this.props;
    return <DollarFormatter value={value} emptyText="No Data" />;
  }
}

export class EditableDollarFormatter extends React.Component {
  render() {
    let { value } = this.props;
    return <DollarFormatter value={value} emptyText="Enter New Rate" />;
  }
}

export class PreviewDollarFormatter extends React.Component {
  render() {
    let { value } = this.props;
    return <DollarFormatter value={value} emptyText="Preview" />;
  }
}

export default DollarFormatter;




// WEBPACK FOOTER //
// ./src/components/DollarFormatter/DollarFormatter.js